// src/components/Blog/BlogLayout.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function BlogLayout({
  children,
  title,
  breadcrumb = [{ label: "Home", to: "/" }, { label: "Blog", to: "/blog" }],
  meta,
  leftRail,
}) {
  const formattedDate =
    meta?.date
      ? new Date(meta.date).toLocaleDateString(undefined, {
          year: "numeric",
          month: "short",
          day: "2-digit",
        })
      : null;

  return (
    <div className="bg-white">
      {/* HERO */}
      <section className="border-b bg-gradient-to-b from-gray-50 to-white">
        <div className="mx-auto max-w-6xl px-5 py-8">
          <nav className="text-sm text-gray-500 mb-4">
            {breadcrumb.map((b, i) => {
              const isLast = i === breadcrumb.length - 1;
              return (
                <span key={`${b.label}-${i}`}>
                  {b.to && !isLast ? (
                    <Link to={b.to} className="hover:text-orange-600">
                      {b.label}
                    </Link>
                  ) : (
                    <span className="text-gray-700">{b.label}</span>
                  )}
                  {!isLast && <span className="mx-2">/</span>}
                </span>
              );
            })}
          </nav>

          <h1 className="text-3xl md:text-4xl font-bold leading-tight text-gray-900">
            {title}
          </h1>

          {(meta?.author || formattedDate || meta?.reading_time) && (
            <p className="mt-3 text-sm text-gray-500">
              {meta?.author && <span>{meta.author}</span>}
              {formattedDate && <span> • {formattedDate}</span>}
              {meta?.reading_time && <span> • {meta.reading_time}</span>}
            </p>
          )}
        </div>
      </section>

      {/* BODY — important: do NOT clip overflow on ancestors of the sticky aside */}
      <section className="mx-auto max-w-6xl px-5 py-10 overflow-visible">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Make the ASIDE sticky */}
          <aside className="md:col-span-4 lg:col-span-3 md:sticky md:top-24 self-start">
            {leftRail}
          </aside>

          {/* Main article */}
          <article className="md:col-span-8 lg:col-span-9 md:pl-10 md:border-l">
            {children}
          </article>
        </div>
      </section>
    </div>
  );
}
